{
  "common": {
    "to": "saakka",
    "from": "lähtien"
  },
  "missing_info": {
    "clinical_history": "Mikä on sairaushistoria?\nSairaushistoria sisältää kaikki eläinlääkärikäynnit sairauden, vamman, rutiinitarkastusten tai rokotusten vuoksi sekä kunkin käynnin päivämäärän ja vastaavat eläinlääkärin huomautukset. Asiakirjan jokainen sivu on numeroitava ja viimeisellä sivulla on oltava klinikan allekirjoitus ja leima. Sen pitäisi myös sisältää lausunto, jossa vahvistetaan, että luetellut käynnit ovat ainoat kerrat, joina lemmikkisi on käynyt kyseisessä klinikassa.\n\nMiten voin saada sairaushistorian?\nHyvin helposti! Kysy vain eläinlääkäriltäsi. Hän voi antaa sen. Jos olet käynyt useammalla kuin yhdellä klinikalla, sinun täytyy kysyä sitä jokaiselta erikseen. Vaikka lemmikkisi olisi käynyt vain rokotuksessa, me silti tarvitsemme täyden sairaushistorian nämä käynnit mukaan lukien.",
    "vet_report": "Eläinlääkärin raportti\nTämän raportin pitäisi kattaa tietty käynti, josta pyydät korvausta. Sen on sisällettävä seuraavat tiedot:\n\n- Käynnin syy (esim. ”koirani jalkaan sattuu.\")\n- Havaitut oireet (esim. ”kipu koskettaessa, ontuminen, kyhmy jalassa…”)\n- Oireiden alkamispäivä\n\n- Diagnostiset testit suoritettu (esim. röntgenkuvat, fyysinen tutkimus…)\n\n- Diagnoosi (esim. \"ruhjevamma takajalassa.\")\n\n- Annettu hoito (esim. \"lepo, tulehduskipulääke, lääkitys...\")\n\n- Varattu tarkastuspäivämäärä",
    "invoice": "Lasku\nJotta lasku olisi kelvollinen, siinä on oltava:\n\nLaskun lähettämispäivä\n\n- Eläinklinikan tai apteekin ALV-numero (CIF/NIF)\n\n- Laskun numero\n\n- Sana lasku on oltava selvästi näkyvissä - emme hyväksy kuitteja, tilauskuitteja tai arvioita\n\n- Kustannusten jakautuminen eläinlääkärin määräämien hoitojen tai lääkkeiden mukaan\n\nJos olet lähettänyt voimassa olevan laskun, mutta kuva on epäselvä, heikkolaatuinen tai epäselvä, lähetä uusi kuva, jossa kaikki tiedot ovat selvästi luettavissa.",
    "health": {
      "templates": [
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "One single document",
              "value": "Lähetä lasku yhtenä asiakirjana, mieluiten PDF-muodossa. Nykyinen muoto ei anna meille mahdollisuutta seurata sisältöä oikein. Jos eläinlääkärisi antoi sinulle tulostetun laskun, ja sinä otat siitä valokuvan, varmista, että kuvassa näkyy koko lasku.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Duplicated invoice",
              "value": "Lähettämäsi laskun numero on jo lähetetty.\n\nJokaisella laskulla on oltava yksilöllinen numero - ei voi olla kahta laskua samalta palveluntarjoajalta ja vuodelta samalla numerolla.\n\nMene klinikallesi ja pyydä heitä lähettämään kelvollinen uusi allekirjoitettu ja leimattu lasku\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Duplicated invoice for another animal",
              "value": "Lähettämäsi laskun numero on jo käytetty toiselle lemmikille.\nKuten yllä, jokaisella laskulla on oltava yksilöllinen numero palveluntarjoajaa ja vuotta kohden.\nPyydä klinikkaasi lähettämään uusi allekirjoitettu ja leimattu lasku.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "The receipt covers the invoice",
              "value": "Kuitti kattaa laskun, joten emme voi lukea sitä. Lähetä selkeämpi versio.\n\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Duplicated invoice",
              "value": "Olemme saaneet tältä klinikalta laskun, jossa on sama laskunumero, mutta eri lemmikkieläimelle, joten se ei ole kelvollinen.\nJokaisella laskulla on oltava yksilöllinen numero - ei voi olla kahta laskua samalta laskun laatijalta ja vuodelta samalla laskun numerolla.\nOta yhteyttä klinikkaasi ja pyydä heitä lähettämään kelvollinen lasku.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "More than one pet",
              "value": "Lasku sisältää useamman kuin yhden lemmikin kuluja. Lähetä erillinen lasku jokaisesta vakuutetusta lemmikistä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Invoice",
              "value": "Me tarvitsemme laskun annetuista palveluista. Muista, että siinä on oltava klinikan CIF/NIF-numero, laskun numero ja palvelun päivämäärä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Unreadable",
              "value": "Lähettämääsi asiakirjaa ei voi lukea selkeästi.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Wrong pet",
              "value": "Lasku ei täsmää vakuutetun lemmikin kanssa.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Unpaid invoice",
              "value": "Lasku on joko maksamaton tai maksettu osittain. Me voimme hyväksyä vain täysin maksetut laskut.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Not an invoice",
              "value": "Lähettämäsi lasku ei ole lasku.\nÄlä huoli. Sinun tarvitsee vain palata eläinlääkäriin tai apteekkiin ja pyytää heitä laatimaan virallinen lasku. Siinä on oltava klinikan CIF/NIF-numero, laskun numero ja kulun päivämäärä.\nVakuutuksen ehtojen mukaisesti me voimme hyväksyä vain viralliset laskut.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Invoice number",
              "value": "Lähettämästäsi laskusta puuttuu laskun numero.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Deposit",
              "value": "Lähettämästäsi laskusta näkyy, että suoritit osittaisen maksun jo aiemmin. Jotta voimme käsitellä korvauksen, tarvitsemme myös laskun kyseisestä ensimmäisestä maksusta.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Olemme vastaanottaneet korvaushakemuksesi, mutta emme voi hyväksyä kuvakaappauksia tai näytöistä otettuja valokuvia asiakirjoista. Pyydäthän klinikaltasi asiakirjat PDF-muodossa ja liität ne sovelluksen kautta."
            },
            {
              "label": "Signed and stamped",
              "value": "Tarvitsemme eläinlääkärisi allekirjoittaman ja leimaaman laskun.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            }
          ]
        },
        {
          "group": "CLINICAL_HISTORY",
          "options": [
            {
              "label": "Clinical history",
              "value": "Me tarvitsemme lemmikkisi koko sairaushistorian siitä lähtien, kun se on ollut kanssasi. Pyydä tätä kaikilta klinikoilta, joissa lemmikkisi on käynyt. Sen on sisällettävä:\n- Kaikki eläinlääkärikäynnit: rokotukset, tarkastukset, sairaukset tai onnettomuudet\n\n- Käyntien päivämäärät ja eläinlääkärin muistiinpanot\n\n- Klinikan huomautus, jossa vahvistetaan, että tietue on valmis, kuten: ”Tällä klinikalla ei ole rekisteröity muita käyntejä.\"\n\n- Klinikan allekirjoitus ja leima\n\n- Yksi tietue klinikkaa kohti: Jos olet käynyt useammalla kuin yhdellä klinikalla, tarvitsemme kunkin klinikan sairaushistorian, vaikka kyseessä olisi ollut vain lemmikkisi rokottaminen.\n\n- Huolimattomia tai keskeneräisiä sivuja ei hyväksytä"
            },
            {
              "label": "Individual pages",
              "value": "Tarvitsemme historian yhtenä, järjestettynä asiakirjana. Me emme voi hyväksyä huolimattomia tai sekavia sivuja."
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Mitä puuttuu?",
                "options": [
                  {
                    "label": "Condition: ",
                    "value": "Eläinlääkäriraportissa mainittuun terveydentilaan {{condicion}} liittyvä käynti puuttuu."
                  },
                  {
                    "label": "Clinic details: ",
                    "value": "Klinikan nimi, CIF tai osoite puuttuu."
                  },
                  {
                    "label": "Pet details",
                    "value": "Lemmikin nimi, rotu tai sirunumero puuttuu."
                  },
                  {
                    "label": "Visit dates",
                    "value": "Nämä päivämäärät puuttuvat: {{fechas}}"
                  },
                  {
                    "label": "Clinical notes",
                    "value": "Sairaushistoria ei sisällä kaikkia eläinlääkärin muistiinpanoja jokaiselta käynniltä."
                  },
                  {
                    "label": "One or more clinics",
                    "value": "Eläinlääkärikäynnit yhdeltä tai useammalta klinikalta puuttuvat: {{nombre_clínica;STRING;true}}."
                  }
                ]
              }
            },
            {
              "label": "Not a clinical history",
              "value": "Lähettämäsi asiakirja ei ole kelvollinen sairaushistoria. Pyydä se kaikilta klinikoilta, joissa lemmikkiäsi on hoidettu. Sen on sisällettävä:\n\n- Kaikki eläinlääkärikäynnit: Olipa kyse rokotuksista, rutiinitarkastuksista, sairauksista tai onnettomuuksista.\n\n- Kunkin käynnin päivämäärät ja eläinlääkärin kirjoittamat muistiinpanot.\n\n- Vahvistus siitä, että historia on täydellinen: Eläinlääkärin on kirjoitettava tähän tyyliin: \"Tällä klinikalla ei ole rekisteröity muita käyntejä.\"\n\n- Klinikan allekirjoittama ja leimaama.\n\n- Yksi historia klinikkaa kohti: Jos olet käynyt useammalla kuin yhdellä klinikalla, tarvitsemme kunkin klinikan historian, vaikka kyseessä olisi ollut vain rokottaminen.\n\n- Me emme hyväksy huolimattomia sivuja tai puutteellisia asiakirjoja."
            },
            {
              "label": "Repeated attempts",
              "value": "Kuten mainitsimme aikaisemmin me emme voi käsitellä pyyntöäsi ilman lemmikkisi sairaushistoriaa. Pyydä se kaikilta klinikoilta, joissa lemmikkiäsi on hoidettu. Sen on sisällettävä:\n- Kaikki eläinlääkärikäynnit: Olipa kyse rokotuksista, rutiinitarkastuksista, sairauksista tai onnettomuuksista.\n\n- Kunkin käynnin päivämäärät ja eläinlääkärin kirjoittamat muistiinpanot.\n\n- Vahvistus siitä, että historia on täydellinen: Eläinlääkärin on kirjoitettava tähän tyyliin: \"Tällä klinikalla ei ole rekisteröity muita käyntejä.\"\n\n- Klinikan allekirjoittama ja leimaama.\n\n- Yksi historia klinikkaa kohti: Jos olet käynyt useammalla kuin yhdellä klinikalla, tarvitsemme kunkin klinikan historian, vaikka kyseessä olisi ollut vain rokottaminen.\n\n- Me emme hyväksy huolimattomia sivuja tai puutteellisia asiakirjoja."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Clarification of cost line",
              "value": {
                "group": "Tarkenna",
                "options": [
                  {
                    "label": "All",
                    "value": "Pyydä eläinlääkäriä sisällyttämään raporttiin tai laskun liitteeksi erittely, josta käy ilmi, mihin hoitoon kukin laskussa oleva nimike viittaa, koska joitakin nimikkeitä ei ole selkeästi määritelty. Raportin on sisällytettävä hoidon nimi ja sen kustannus.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "One or more costlines",
                    "value": "Pyydä eläinlääkäriä sisällyttämään raporttiin tai laskun liitteeksi, mihin hoitoon seuraavat laskunimikkeet viittaavat: {{línea_de_coste;STRING;true}}. Raportin on sisällytettävä hoidon nimi ja sen kustannus.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            },
            {
              "label": "Sessions",
              "value": "Tarvitsemme raportin, jossa näkyvät kaikki käynnit ja niiden päivämäärät. Lähetä se, kun koko hoito on suoritettu, koska emme voi korvata tulevia käyntejä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Changes",
              "value": "Eläinlääkärin raportit ovat virallisia asiakirjoja. Me emme voi hyväksyä muokattuja asiakirjoja. Pyydä eläinlääkäriäsi lähettämään uuden, allekirjoitetun ja leimatun raportin, jossa on perustelut muutoksille.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "One single document",
              "value": "Lähetä raportti yksittäisenä tiedostona mieluiten PDF-muodossa. Lähetystapa vaikeuttaa sisällön seuraamista oikeassa järjestyksessä. Jos eläinlääkärisi antoi sinulle tulostetun raportin ja sinun on otettava siitä valokuva, varmista, että lähetät yhden selkeän kuvan sivua kohden ja näytät koko sivun oikeassa järjestyksessä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Vet report",
              "value": {
                "group": "Mitä puuttuu?",
                "options": [
                  {
                    "label": "Clinic",
                    "value": "Meiltä puuttuu seuraavien klinikoiden eläinlääkärien raportti: {{clinica;STRING;true}}.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "All",
                    "value": "Me tarvitsemme eläinlääkärin raportin.\nTämän on oltava eläinlääkärin kirjoittama asiakirja, jossa esitetään yksityiskohtaisesti käynti, josta haet korvausta. Raportin on sisällytettävä seuraavat seikat:\n\nKäynnin syy: esim. \"Koirani jalkaan sattuu.\"\n\nHavaitut oireet: esim. \"Kipu koskettaessa, ontuminen, kyhmy jalassa.\"\n\nPäivämäärä, jolloin oireet alkoivat\n\nSuoritetut testit: esim. \"Röntgen, lääkärintarkastus.\"\n\nDiagnoosi: esim. \"Ruhjeeseen liittyvä vamma takajalassa.\"\n\nMäärätty hoito: esim. \"Lepo, lääkitys.\"\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Dates",
                    "value": "Eläinlääkärin raportti puuttuu seuraavilta päiviltä: {{fecha;DATE_RANGE;true}}.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            },
            {
              "label": "Starting date of symptoms",
              "value": {
                "group": "Kenen täytyy antaa oireiden alkamispäivä?",
                "options": [
                  {
                    "label": "Petparent",
                    "value": "Sinun on ilmoitettava meille, milloin oireet ilmenivät esimmäisen kerran.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa.",
                    "type": "PÄIVÄMÄÄRÄ"
                  },
                  {
                    "label": "Veterinarian",
                    "value": "Lähettämäsi raportti ei sisällä oireiden alkamispäivää. Pyydä eläinlääkäriäsi lisäämään tämä tiedo.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            },
            {
              "label": "Incomplete",
              "value": {
                "group": "Mitä puuttuu?",
                "options": [
                  {
                    "label": "Treatments",
                    "value": "Eläinlääkärintodistuksessa ei mainita joitakin laskussa lueteltuja kohteita. Jos esimerkiksi lasku sisältää lääkityksen, mutta raportti ei, on tarpeen, että eläinlääkäri päivittää raportin siten, että se sisältää kaikki annetut hoidot.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Clinic details",
                    "value": "Raportista puuttuu joitakin tai kaikki klinikan tiedot: nimi, verotunnus (CIF) ja osoite.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Pet details",
                    "value": "Raportista puuttuu joitakin tai kaikki lemmikin tiedot: nimi, rotu ja/tai mikrosirun numero.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Diagnosis",
                    "value": "Raportista puuttuu lemmikkisi diagnoosi.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Date of visit",
                    "value": "Raportista puuttuu käynnin päivämäärä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Pages",
                    "value": "Lähettämäsi raportti on puutteellinen - jotkin sivut puuttuvat.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Diagnostic tests",
                    "value": "Raportista puuttuvat lemmikillesi tehdyt diagnostiset testit (kuten röngten, laboratoriotestit jne.).\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Symptoms or reason for visit",
                    "value": "Raportti ei sisällä syytä eläinlääkärikäyntiin — tarvitsemme selkeän kuvauksen lemmikkisi oireista.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Treatment",
                    "value": "Raportista puuttuu lemmikillesi määrätty hoito.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            },
            {
              "label": "Discrepancy of documents",
              "value": "Löysimme lähettämistäsi asiakirjoista seuraavat epäjohdonmukaisuudet: {{inconsistency;STRING;true}}. Pyydä eläinlääkäriä selventämään tämä päivitetyssä raportissa.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Previous condition reports",
              "value": "Tarvitsemme edellisten käyntien raportit liittyen tähän terveydentilaan. Näihin tulisi sisältyä oireet, niiden alkamispäivä, suoritetut testit, määrätyt hoidot ja miten tila on edennyt. Voit lähettää meille koko sairaushistorian, jos tämä on helpompaa.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Previous consultations",
              "value": "Sinun on lähetettävä meille tähän konsultaatioon liittyvien aiempien käyntien raportit.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Costline breakdown",
              "value": "Pyydä eläinlääkäriä tarkentamaan jokainen lemmikillesi annettu palvelu tai hoito ja sen yksilöllinen hinta joko raportissa tai laskun liitteenä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Vet report doesn't match invoice",
              "value": "Lähettämäsi raportti ei täsmää laskun kanssa. Varmista, että raportissa on sama päivämäärä kuin laskussa ja se sisältää kaikki laskutetut tuotteet.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Unreadable",
              "value": "Lähettämäsi asiakirja on lukukelvoton.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Not a vet report",
              "value": "Lähettämäsi asiakirja ei ole kelvollinen eläinlääkärin raportti.\nTämän on oltava eläinlääkärin kirjoittama asiakirja, jossa esitetään yksityiskohtaisesti käynti, josta haet korvausta. Raportin on sisällytettävä seuraavat seikat:\n\n- Käynnin syy: esim. \"Koirani jalkaan sattuu.\"\n- Havaitut oireet: esim. \"Kipu koskettaessa, ontuminen, kyhmy jalassa.\"\n- Päivämäärä, jolloin oireet alkoivat\n- Suoritetut testit esim. \"Röntgen, lääkärintarkastus.\n- \"Diagnoosi esim. \"Ruhjeeseen liittyvä vamma takajalassa.\"\n- Määrätty hoito: esim. \"Lepo, lääkitys.\"\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Chronic condition",
              "value": "Kroonisen lääkityksen korvaamiseksi tarvitsemme eläinlääkäriltäsi seurantaraportin, jossa kerrotaan, miten lemmikkisi voi ja miten hoito etenee. Raportti on päivitettävä 6 kuukauden välein.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Treatment",
              "value": "Lähettämässäsi asiakirjassa on kerrottu eläinlääkärin suosittelemat hoidot, mutta me tarvitsemme käynnin koko raportin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Signed and stamped",
              "value": "Tarvitsemme eläinlääkärisi allekirjoittaman ja leimaaman raportin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Olemme vastaanottaneet korvaushakemuksesi, mutta emme voi hyväksyä kuvakaappauksia tai näytöistä otettuja valokuvia asiakirjoista. Pyydäthän klinikaltasi asiakirjat PDF-muodossa ja liität ne sovelluksen kautta."
            }
          ]
        },
        {
          "group": "ADMINISTRATIVE_DOCUMENTATION",
          "options": [
            {
              "label": "Chip registration certificate",
              "value": "Lähetä meille lemmikkisi sirun rekisteröintitodistus."
            },
            {
              "label": "Purchase or adoption contract",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Missing",
                    "value": "Sinun on lähetettävä meille sopimus lemmikkisi kaupasta tai adoptiosta."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Osto- tai adoptiosopimus: Lähettämäsi asiakirja on lukukelvoton."
                  }
                ]
              }
            },
            {
              "label": "IBAN",
              "value": "Me tarvitsemme IBAN-numerosi.",
              "type": "IBAN"
            }
          ]
        },
        {
          "group": "MEDICAL_IMAGING",
          "options": [
            {
              "label": "Ultrasound",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Ultraääni: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos."
                  },
                  {
                    "label": "Missing",
                    "value": "Me tarvitsemme alkuperäisen ultraääniraportin. Raportin on sisällytettävä lemmikin tiedot ja päivämäärä, jolloin testi suoritettiin."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämääsi ultraääntä ei voi lukea."
                  }
                ]
              }
            },
            {
              "label": "Radiography",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Röntgen: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos."
                  },
                  {
                    "label": "Missing",
                    "value": "Lähetä meille alkuperäisellä vesileimalla tai DICOM-muodossa (.dcm) otetut röntgenkuvat."
                  },
                  {
                    "label": "Original images",
                    "value": "Me tarvitsemme alkuperäiset röngtenkuvat. Nämä voivat olla DICOM-muodossa (.dcm). Tämä muoto on vastaava kuin jpg valokuville. Vaikka sinä et saisi niitä auki, me saamme."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämääsi röngtenkuvaa ei voi lukea."
                  }
                ]
              }
            },
            {
              "label": "MRI",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Magneettikuvaus: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos."
                  },
                  {
                    "label": "Missing",
                    "value": "Me tarvitsemme alkuperäisen magneettikuvausraportin. Raportin on sisällytettävä lemmikin tiedot ja päivämäärä, jolloin testi suoritettiin."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämääsi magneettikuvaa ei voi lukea."
                  }
                ]
              }
            },
            {
              "label": "CT-Scan",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "CT-skannaus: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos."
                  },
                  {
                    "label": "Missing",
                    "value": "Me tarvitsemme alkuperäisen CT-skannausraportin. Raportin on sisällytettävä lemmikin tiedot ja päivämäärä, jolloin testi suoritettiin."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämääsi CT-skannausta ei voi lukea."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "MEDICAL_ANALYTIC",
          "options": [
            {
              "label": "Blood tests",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Verikoe: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Missing",
                    "value": "Me tarvitsemme verikokeen tulokset tai alkuperäisen asiakirjan. Raportin on sisällytettävä lemmikin tiedot ja päivämäärä, jolloin testi suoritettiin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämäsi verikokeen tuloksia ei voi lukea.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            },
            {
              "label": "Biopsy",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Koepala: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Missing",
                    "value": "Tarvitsemme koepalan tulokset tai alkuperäisen asiakirjan. Raportin on sisällytettävä lemmikin tiedot ja päivämäärä, jolloin testi suoritettiin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämäsi koepalan tuloksia ei voi lukea.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            },
            {
              "label": "Urine test",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Virtsakoe: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Missing",
                    "value": "Me tarvitsemme virtsakokeen tulokset tai alkuperäisen asiakirjan. Raportin on sisällytettävä lemmikin tiedot ja päivämäärä, jolloin testi suoritettiin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämäsi virtsakokeen tuloksia ei voi lukea.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
                  }
                ]
              }
            }
          ]
        },
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Vaccination card",
              "value": {
                "group": "Mitä tapahtuu?",
                "options": [
                  {
                    "label": "Changes",
                    "value": "Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos. Huomautukset-osiossa ilmoitamme, mistä löysimme perustelemattoman muutoksen."
                  },
                  {
                    "label": "Missing Vaccination card",
                    "value": "Lähetä meille kuva rokotuskortista tai passista, jossa näkyvät lemmikin tiedot ja kaikki sen saamat rokotteet."
                  },
                  {
                    "label": "Unreadable",
                    "value": "Lähettämäsi asiakirja on lukukelvoton."
                  },
                  {
                    "label": "Chipnumber",
                    "value": "Lähetä meille kuva rokotuskortista tai passista, jossa näkyy lemmikin sirunumero."
                  }
                ]
              }
            }
          ]
        }
      ]
    },
    "prevention": {
      "templates": [
        {
          "group": "VACCINATION_CARD",
          "options": [
            {
              "label": "Changes",
              "value": "Rokotuskortti: Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos."
            },
            {
              "label": "Missing Vaccination card",
              "value": "Lähetä meille kuva rokotuskortista tai passista, jossa näkyy tämä rokote ja kaikki otetut rokotteet."
            },
            {
              "label": "Unreadable",
              "value": "Lähettämääsi rokotuskorttia ei voi lukea."
            },
            {
              "label": "Chipnumber",
              "value": "Lähetä meille kuva rokotuskortista tai passista, jossa näkyy lemmikin sirunumero."
            }
          ]
        },
        {
          "group": "INVOICE",
          "options": [
            {
              "label": "Changes",
              "value": "Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Tax ID number",
              "value": "Lähettämästäsi laskusta puuttuu CIF-numero tai se on puutteellinen.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Receipt covers the invoice",
              "value": "Kuitti peittää osan laskusta, emmekä voi lukea sen sisältöä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Duplicated invoice",
              "value": "Olemme saaneet tältä klinikalta laskun, jossa on sama laskunumero, mutta eri lemmikkieläimelle, joten se ei ole kelvollinen. Laskuilla on oltava yksilöllinen numero - ei voi olla kahta laskua samalta laskun laatijalta ja vuodelta samalla numerolla. Käy klinikallasi ja pyydä heitä lähettämään kelvollinen lasku.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "More than one pet",
              "value": "Lähettämässäsi laskussa on useisiin lemmikkeihin liittyviä kustannuksia. Lähetä yksilöllinen lasku jokaisesta vakuutetusta lemmikistä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Missing",
              "value": "Sinun on lähetettävä meille lasku tarjotuista palveluista. Muista, että siinä on oltava klinikan CIF/NIF-numero, laskun numero ja kulun päivämäärä.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Unreadable",
              "value": "Lähettämääsi laskua ei voi lukea.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Not an invoice",
              "value": "Rokotelaskuna toimitettu asiakirja ei ole kelvollinen. Sinun on lähetettävä meille lasku tai yksityiskohtainen kuitti, jossa näkyvät eläinlääkäriasemasi tiedot, sinun tietosi ja lemmikkisi tiedot sekä erittely annetuista rokotteista.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "One single document",
              "value": "Lähetä lasku meille yhtenä asiakirjana, mieluiten PDF-muodossa. Nykyisessä muodossaan emme pysty seuraamaan sisällön järjestystä oikein. Jos eläinlääkärisi antoi laskun tulostettuna ja sinun täytyy ottaa siitä kuvia, varmista, että lasku näkyy kokonaan yhdessä kuvassa.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Screenshots not accepted",
              "value": "Olemme vastaanottaneet korvaushakemuksesi, mutta emme voi hyväksyä kuvakaappauksia tai näytöistä otettuja valokuvia asiakirjoista. Pyydäthän klinikaltasi asiakirjat PDF-muodossa ja liität ne sovelluksen kautta."
            },
            {
              "label": "Signed and stamped",
              "value": "Tarvitsemme eläinlääkärisi allekirjoittaman ja leimaaman laskun.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            }
          ]
        },
        {
          "group": "VET_REPORT",
          "options": [
            {
              "label": "Costline clarification",
              "value": "Pyydä eläinlääkäriä sisällyttämään raporttiin tai laskun liitteeksi, mikä hoito vastaa näitä laskun kohtia: {{línea_de_coste;STRING;true}}. Sen on sisällettävä hoidon nimi ja sen hinta.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Changes",
              "value": "Eläinlääkärisi on kirjoitettava suljettu raportti, joka sisältää hänen koko nimen, rekisteröintinumeron ja allekirjoituksen ja jossa selitetään, miksi asiakirjassa on tapahtunut muutos.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Missing",
              "value": "Sinun on liitettävä lähettämääsi laskuun liittyvä eläinlääkärinlausunto.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Costline breakdown",
              "value": "Pyydä eläinlääkäriä sisällyttämään raporttiin tai laskun liitteeksi jokainen lemmikille suoritettu palvelu tai hoito ja sen yksilöllinen hinta.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Vet report doesn't match invoice",
              "value": "Lähettämäsi raportti ei täsmää laskun kanssa. Laskujen on aina liityttävä raportteihin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Unreadable",
              "value": "Lähettämääsi eläinlääkärin raporttia ei voi lukea.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
              "label": "Signed and stamped",
              "value": "Tarvitsemme eläinlääkärisi allekirjoittaman ja leimaaman raportin.\n\nEmme voi hyväksyä kuvakaappauksia tai valokuvia asiakirjojen näytöistä. Pyydä klinikkaasi toimittamaan asiakirjat PDF-muodossa."
            },
            {
            "label": "Screenshots Not Accepted",
            "value": "Olemme vastaanottaneet korvaushakemuksesi, mutta emme voi hyväksyä kuvakaappauksia tai näytöistä otettuja valokuvia asiakirjoista. Pyydäthän klinikaltasi asiakirjat PDF-muodossa ja liität ne sovelluksen kautta."
            }
          ]
        }
      ]
    }
  },
  "resolution": {
    "templates": [
      {
        "group": "Waiting period",
        "options": [
          {
                        "label": "5 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Tarkastettuamme {{petName}}:n asiakirjat, joudumme valitettavasti ilmoittamaan, että laskuasi, tai osaa siitä, ei voitu hyväksyä. Vakuutuksessasi on 5 päivän odotusaika onnettomuuksille sopimuksen alkamispäivästä lukien. Tässä tapauksessa ilmoitettu sairaus: {{condition;STRING;true}}, ilmeni tai sai eläinlääkärinhoitoa: {{date;DATE;true}}, näiden 5 päivän sisällä. Tästä syystä sitä ei kateta vakuutuksella, ja sitä pidetään jo ennen vakuutuksen alkamista olemassa olleena sairautena. Jos tämä sairaus jatkuu pitkään tai ilmenee tulevaisuudessa uudelleen toistuvasti tai kroonisesti, tätä tapausta tai siitä johtuvia mahdollisia uusiutumia tai komplikaatioita ei voida korvata, riippumatta lopullisen diagnoosin päivämäärästä."
          },
          {
                        "label": "28 DAYS WAITING PERIOD / PREEXISTENCE",
                        "value": "Tarkistettuamme {{petName}}:n asiakirjat joudumme valitettavasti ilmoittamaan, että laskuasi, tai osaa siitä, ei voitu hyväksyä. Vakuutuksessasi on 28 päivän odotusaika sairauksille sopimuksen alkamispäivästä lukien. Vakuutus määrittelee erillisen luettelon tilanteista, joihin sovelletaan lyhennettyä 5 päivän odotusaikaa, eikä tämä sairaus valitettavasti kuulu niihin, joten siihen sovelletaan yleistä 28 päivän odotusaikaa. Tässä tapauksessa ilmoitettu sairaus: {{condition;STRING;true}}, ilmeni tai sai eläinlääkärin hoitoa seuraavana päivänä: {{date;DATE;true}}, näiden 28 päivän sisällä, ja se luokitellaan sairaudeksi, koska se ei täytä vakuutusehdoissa tapaturmalle asetettuja edellytyksiä. Tämän vuoksi se ei kuulu vakuutuksen piiriin ja sitä pidetään aiemmin olemassa olleena sairautena. Jos tämä sairaus jatkuu pitkään tai ilmenee tulevaisuudessa uudelleen toistuvasti tai kroonisesti, ei tätä tapausta eikä siitä mahdollisesti aiheutuvia uusiutumisia tai komplikaatioita voida korvata, riippumatta lopullisen diagnoosin päivämäärästä."
          },
          {
            "label": "6 MONTH WAITING PERIOD / PREEXISTENCE",
                        "value": "Tarkistettuamme {{petName}}:n asiakirjat ilmoitamme, että laskuanne, tai osaa siitä, ei voitu hyväksyä. Vakuutuksessanne on 6 kuukauden odotusaika tietyille sairauksille sopimuksen alkamispäivästä lukien. Näihin sairauksiin kuuluvat muun muassa: lonkkanivelen dysplasia, kyynärnivelen dysplasia, ristisiteen repeämä tai sairaus, polvilumpion sijoiltaanmeno, atopia, allerginen ihotulehdus, epilepsia, käyttäytymishäiriöt, leishmanioosi, kaihi ja välilevytyrä. Jos lemmikki oli yli 6 kuukauden ikäinen vakuutusta otettaessa, nämä sairaudet kuuluvat tämän 6 kuukauden odotusajan piiriin, vaikka niiden alkuperä saattaisi liittyä odottamattomaan tapahtumaan. Tässä tapauksessa ilmoitettu sairaus: {{condition;STRING;true}}, ilmeni tai sitä hoidettiin: {{date;DATE;true}}, tämän 6 kuukauden ajanjakson sisällä. Tämän vuoksi se ei kuulu vakuutuksen piiriin ja sitä pidetään olemassa olevana sairautena ennen vakuutuksen alkua. Tämä sairaus jää korvauksen ulkopuolelle myös jatkossa: koska ensimmäiset oireet tai ensimmäinen niihin liittyvä eläinlääkärikäynti tapahtuivat vakuutuksen odotusaikana, emme voi hyväksyä tulevia tähän sairauteen tai siitä johtuvaan oireeseen, vammaan tai sairauteen liittyviä korvaushakemuksia. Tätä sairautta pidetään pysyvästi ennen vakuutusta olemassa olleena, vaikka lopullinen diagnoosi vahvistettaisiin myöhemmin."
          },
          {
            "label": "Leishmania",
            "value": "Leishmaniaasi. Leishmanioosi on krooninen sairaus, jonka kehittyminen infektion jälkeen kestää kuukausia tai jopa vuosia. Lemmikilläsi on diagnosoitu pitkälle edennyt tai keskivaikea infektio (vaihe __ - keskivaikea/pitkälle edennyt tauti). Kun otetaan huomioon tämän sairauden hidas kehitys ja oireiden ilmenemispäivä, tauti oli aktiivinen ja läsnä odotusaikana tai ennen vakuutuksen solmimista."
          }
        ]
      },
      {
                "group": "Preexistence",
        "options": [
          {
                        "label": "Preexistence/before contract",
                        "value": "Tarkastettuamme {{petName}}:n asiakirjat ilmoitamme, että laskuasi, tai osaa siitä, ei voitu hyväksyä.\n\nLemmikkisi sairaus tai vamma: {{condition;STRING;true}}, katsotaan olevan olemassa jo ennen vakuutuksen alkamista, koska se ilmeni, aiheutti oireita tai sitä hoidettiin ensimmäisen kerran: {{date;DATE;true}}, eli ennen vakuutusturvan alkamista.\n\nAiemmin olemassa oleva sairaus tai vamma tarkoittaa mitä tahansa vammaa tai sairautta, joka: on ilmennyt tai aiheuttanut kliinisiä oireita ennen vakuutusturvan alkamista, tai jolla on sama diagnoosi tai samat oireet kuin vammalla tai sairaudella, joka lemmikillä oli jo ennen vakuutusturvan alkamista, tai joka johtuu, liittyy tai on seurausta vammasta, sairaudesta tai kliinisestä oireesta, joka ilmeni ennen vakuutusturvan alkamista.\n\nLisäksi tämä sairaus jää korvauksen ulkopuolelle myös jatkossa. Tämä tarkoittaa, ettemme voi hyväksyä tulevia korvaushakemuksia, jotka liittyvät tähän sairauteen tai mihin tahansa siitä johtuvaan oireeseen, vammaan tai sairauteen, vaikka lopullinen diagnoosi vahvistettaisiin myöhemmin."
          },
          {
            "label": "Date outside coverage period",
            "value": "Lasku lähetettiin ennen vakuutuksen alkamista: Valitettavasti korvauspyyntösi on hylätty, koska lähettämäsi laskun päivämäärä on ennen vakuutuksen alkamispäivää."
          },
          {
            "label": "Not an accident denial",
            "value": "Olemme tarkistaneet korvaushakemuksesi, ja vakuutuksesi yleisten ehtojen mukaisesti tätä tapausta ei voida pitää tapaturmana vakuutusturvan kannalta.\n\nVakuutusehtojen mukaan tapaus voidaan katsoa tapaturmaksi vain, jos se täyttää vakuutussopimuksessa määritellyn tapaturman määritelmän ja kuuluu yksinomaan johonkin seuraavista ryhmistä:\n\nTapaturman aiheuttamat murtumat tai nivelten sijoiltaanmenot.\nIhorepeämät, puremahaavat (lukuun ottamatta hyönteisten pistoja) tai ihon hiertymät.\nPalovammat tai sähköiskun aiheuttamat vammat.\nAjoneuvon aiheuttamat vammat.\nMyrkytykset.\nAmpuma-aseen tai ammuksen aiheuttamat vammat.\nVakavat ruhjeet tai murskavammat.\nTapaturman aiheuttamat hammasvammat.\nRuoansulatuskanavan vierasesineet.\n\nLisäksi yleisissä ehdoissa todetaan nimenomaisesti, että vammat tai sairaudet, jotka traumaattisesta tapahtumasta huolimatta kuuluvat sairauteen, jolle on vakuutussopimuksessa määritelty erityinen odotusaika, kuuluvat kyseisen odotusajan piiriin eivätkä tapaturmien odotusajan piiriin.\n\nTästä syystä tähän tapaukseen sovelletaan 28 päivän odotusaikaa, eikä tapaturmille tarkoitettua 5 päivän odotusaikaa.\n\nKoska oireet ja/tai hoito ilmenivät tämän odotusajan aikana, emme valitettavasti voi korvata kyseisiä kustannuksia."
          }
        ]
      },
      {
        "group": "Vaccinations are not up to date",
        "options": [
          {
            "label": "Vaccinations are not up to date",
            "value": "Vuosittaiset rokotukset eivät ole ajan tasalla. Vakuutuksesi yleisten ehtojen mukaan lemmikkisi raivotauti-, penikkatauti-, hepatiitti- ja parvovirusrokotukset on oltava ajan tasalla. Tällöin rokotusohjelma on puutteellinen tai eläinlääkärin ohjeita ei ole noudatettu. Tämän taudin kehittymiseen liittyviä eläinlääkintäkustannuksia ei voida kattaa."
          }
        ]
      },
      {
        "group": "Clinical history disclaimer",
        "options": [
          {
            "label": "Clinical history disclaimer",
            "value": "Sairaushistoria. Muistutan, että seuraavaa korvauspyyntöä varten sinun on lähetettävä lemmikkisi sairaushistoria. Sairaushistorian on sisällettävä kaikki eläinlääkärikäynnit sairauden, onnettomuuden, rutiinitarkastusten tai rokotusten vuoksi sekä käynnin päivämäärän ja vastaavat eläinlääkärin huomautukset. Jos lemmikkisi on käynyt useammalla kuin yhdellä klinikalla, sinun on pyydettävä sairaushistoria kaikilta klinikoilta. Tämän asiakirjan jokainen sivu on numeroitava ja viimeisellä sivulla on oltava klinikan allekirjoitus ja leima. Sinun on myös lisättävä todistus siitä, että sairaushistoriaan kirjatut käynnit ovat lemmikkisi ainoita käyntejä kyseiselle klinikalle."
          },
          {
            "label": "Disclaimer: Certificate of chronic disease control",
            "value": "Arviointiraportti. Muistutamme, että kroonisten lääkkeiden korvaaminen edellyttää tarkistusta 6 kuukauden välein. Sinun on lähetettävä meille arviointiraportti seuraavan pyyntösi yhteydessä."
          },
          {
            "label": "Prostheses, implants, pacemakers and transplants",
            "value": "Vakuutuksen yleisten ehtojen mukaan vakuutuksesta on rajattu pois elinsiirrot (mukaan lukien leikkausta edeltävä ja sen jälkeinen hoito), sydämentahdistimet, proteesit, implantit (lukuun ottamatta osteosynteesi-implantteja) sekä keinotekoiset ruumiinosat ja tekonivelet."
          }
        ]
      },
      {
        "group": "Routine or preventive treatments",
        "options": [
          {
            "label": "Routine or preventive treatments",
            "value": "Ennaltaehkäisevä hoito. Barkibun vakuutus kattaa vain sairaudesta tai tapaturmasta aiheutuvat eläinlääkärikulut. Ilmoittamasi kulut liittyvät rutiini- tai ennaltaehkäiseviin hoitoihin, joten niitä ei kateta."
          }
        ]
      },
      {
        "group": "Unjustified costlines",
        "options": [
          {
            "label": "Unjustified costlines",
            "value": "Osa ilmoitetuista kuluista ei ole riittävästi perusteltu toimitetussa dokumentaatiossa, eikä niitä voida siksi arvioida vakuutusehtojen mukaisesti."
          }
        ]
      },
      {
        "group": "Outside EU, UK and Andorra",
        "options": [
          {
            "label": "Outside EU, UK and Andorra",
            "value": "Vakuutuksesi ei kata kuluja, jotka syntyvät Euroopan unionin, Yhdistyneen kuningaskunnan ja Andorran ulkopuolella."
          }
        ]
      },
      {
        "group": "Complementary sessions limit reached",
        "options": [
          {
            "label": "Complementary sessions limit reached",
            "value": "Olet jo saavuttanut vuotuisen 8 käynnin enimmäismäärän"
          }
        ]
      },
      {
        "group": "Our condolences",
        "options": [
          {
            "label": "Our condolences",
            "value": "Haluan lähettää sinulle koko Barkibun tiimin puolesta mahdollisimman paljon voimia näinä vaikeina aikoina. Olemme syvästi pahoillamme tapahtuneesta."
          }
        ]
      },
      {
        "group": "Ennaltaehkäisy",
        "options": [
          {
            "label": "Vaccinations not covered",
            "value": "Kattamaton rokote: Eläinlääkärivakuutuksesi ennaltaehkäisevä hoitopaketti sisältää raivotauti-, yhdistelmä- ja kennelyskärokotteet koirille ja raivotauti-, kolmois- ja leukemiarokotteet kissoille."
          },
          {
            "label": "Annual visit with tests",
            "value": "Vuositarkastus ja testit: Eläinlääkärivakuutuksen ennaltaehkäisevä hoitopaketti sisältää vuosittaisen ennaltaehkäisevän tarkastuksen, joka ei liity mihinkään lemmikin sairauteen, onnettomuuteen tai oireisiin. Tämä tarkastus ei sisällä lemmikkisi testejä tai analyysejä. Lähettämäsi arvostelu ei täytä näitä vaatimuksia, joten sitä ei kateta."
          }
        ]
      }
    ]
  },
  "close_claim": {
    "templates": [
      {
        "group": "Missing information",
        "options": [
          {
            "label": "Missing information",
            "value": "Pyyntö suljettu.Ilmoitan, että olemme sulkeneet pyyntösi, koska tähän mennessä toimitettujen asiakirjojen perusteella meillä ei ole riittävästi tietoja arvioinnin tekemiseen. Olemme yrittäneet ottaa sinuun yhteyttä useita kertoja pyytääksemme sinua lähettämään asiakirjat oikein, mutta siinä onnistumatta. Älä huoli, kun sinulla on tarvittavat asiakirjat, voit luoda uuden korvauspyynnön, ja me tarkistamme sen uudelleen. Voit tarkistaa aiemmat sähköpostimme varmistaaksesi, että tiedät, mitä tarvitsemme asiakirjojen vahvistamiseen."
          },
          {
            "label": "Outstanding documents in another request",
            "value": "Pyyntö suljettu. Suljemme tämän pyynnön, koska se liittyy toiseen pyyntöön, joka on edelleen avoinna ja odottaa asiakirjoja. Lataa nämä asiakirjat avoimeen pyyntöön sovelluksen kautta."
          },
          {
            "label": "Suspended/cancelled policy",
            "value": "Pyyntö suljettu. Ilmoitan, että olemme sulkeneet pyyntösi, koska vakuutuksesi on keskeytetty tai peruutettu. Olemme yrittäneet ottaa sinuun yhteyttä useita kertoja maksun päivittämiseksi ja vireillä olevien veloitusten käsittelemiseksi, mutta siinä onnistumatta. Kun olet selvittänyt tilanteen, voit lähettää pyyntösi uudelleen sovelluksen kautta."
          },
          {
            "label": "Fraud",
            "value": "Tarkistettuamme toimittamasi asiakirjat olemme havainneet epäjohdonmukaisuuksia, joiden vuoksi emme voi hyväksyä korvaushakemustasi.\n\nTästä lähtien kaikki tulevia korvauksia koskevat asiakirjat on lähetettävä suoraan eläinlääkäriklinikaltasi osoitteeseen clinic@barkibu.com.\n\nKun klinikkasi on lähettänyt ne, on tärkeää, että avaat uuden hakemuksen sovelluksen kautta samoilla asiakirjoilla ja lisäät huomautuksen: ”Klinikkani on jo lähettänyt asiakirjat”, jotta voimme käsitellä sen.\n\nJotta korvaustesi käsittely olisi sujuvampaa, älä koskaan luo hakemusta asiakirjoilla, joita klinikkasi ei ole aiemmin lähettänyt meille edellä mainittuun sähköpostiosoitteeseen."
          },
          {
            "label": "No response from clinic",
            "value": "Olemme sulkeneet korvaushakemuksesi, koska tähän mennessä toimitetuilla asiakirjoilla meillä ei ole riittävästi tietoja arvion tekemiseksi. Yritimme ottaa yhteyttä klinikkaasi useita kertoja tietojen täydentämiseksi, mutta emme onnistuneet.\n\nJotta voimme käsitellä hakemuksesi, ota yhteyttä klinikkaasi ja pyydä heitä tarkistamaan sähköpostinsa.\n\nKun he ovat vastanneet meille, voit avata hakemuksen uudelleen sovelluksen kautta."
          },
          {
            "label": "Fraud documentation from clinic",
            "value": "Aiemmissa korvaushakemuksissa havaittujen epäjohdonmukaisuuksien vuoksi eläinklinikkasi on tästä lähtien lähetettävä kaikki tulevia korvauksia koskevat asiakirjat suoraan osoitteeseen clinic@barkibu.com.\n\nKun klinikkasi on lähettänyt asiakirjat, on tärkeää, että teet sovelluksessa uuden hakemuksen samoilla asiakirjoilla ja lisäät merkinnän: ”Klinikkani on jo lähettänyt asiakirjat\", jotta voimme käsitellä sen.\n\nKorvaustesi käsittelyn helpottamiseksi älä koskaan luo hakemusta asiakirjoilla, joita klinikkasi ei ole ensin lähettänyt meille yllä mainittuun sähköpostiosoitteeseen."
          }
        ]
      }
    ]
  }
}
